require('./angular-messages');
module.exports = 'ngMessages';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-messages/index.js
 ** module id = 800
 ** module chunks = 8
 **/